export default Object.freeze({
  REDSHIFT: 'redshift',
  SNOWFLAKE: 'snowflake',
  POSTGRES: 'postgres_sink',
  MYSQL: 'mysql_sink',
  S3: 's3',
  PINTEREST: 'pinterest',
  BIGQUERY: 'bigquery',
  TEST: 'test',
});
